import {Component} from '@angular/core';
import {ModalBaseComponent} from '~shared/ng/components/dialog/base/modal-base.component';
import {NgIf} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {ValidationCssDirective} from '~shared/ng/modules/validation/directives/validation/validation-css.directive';
import {ValidationErrorComponent} from '~shared/ng/modules/validation/components/validation/validation-error.component';
import {provideValidationWithRules, ValidationModule} from '~shared/ng/modules/validation/validation.module';
import {formDisabledSourceProvider} from '~shared/ng/modules/validation/directives/utils/form-disabled.directive';
import {MaxLengthRule, MinLengthRule, RequiredRule} from '~shared/ng/modules/validation/rules/rules';
import {ValidationSubmitEvent} from '~shared/ng/modules/validation/directives/check/validation-check-base.directive';

type AuthForm = {
    authenticatorCode: string,
};

@Component({
    standalone: true,
    selector: 'app-two-factor-auth-dialog',
    templateUrl: './two-factor-auth-dialog.component.html',
    viewProviders: [
        formDisabledSourceProvider,
    ],
    providers: [
        provideValidationWithRules({
            confirmCodeForm: {
                authenticatorCode: [new RequiredRule(), new MaxLengthRule(6), new MinLengthRule(6)]
            }
        })
    ],
    imports: [
        ValidationModule,
        FormsModule,
        ValidationErrorComponent,
        NgIf,
        RouterLink,
        TranslateModule,
        ValidationCssDirective
    ]
})
export class TwoFactorAuthDialogComponent extends ModalBaseComponent<{}, AuthForm> {

    public submit($event: ValidationSubmitEvent<AuthForm>): void {
        this.close($event.formData);
    }
}
